module.exports = __webpack_public_path__ + "assets/tick-rounded.8d197e13e8ffaa609d35859de904c068.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/tick-rounded.png
 ** module id = 268
 ** module chunks = 0
 **/